// React
import { useCallback } from 'react'

// Interfaces
import {
  IRoleGetDetailAttrs,
  IRoleGetDropdownAttrs,
  IRoleGetListAttrs,
  IRoleSaveAttrs,
} from 'interfaces/back-office/master/role/role-view.interface'

// Models
import { useStores } from 'models'

const useMasterRole = () => {
  // Hook
  const {
    masterRole: {
      masterRole_loading,
      masterRole_list,
      masterRole_detail,
      masterRole_dropdown,
      masterRole_CLEAR_LIST,
      masterRole_CLEAR_DETAIL,
      masterRole_CLEAR_DROPDOWN,
      masterRole_fetchList: fetchList,
      masterRole_fetchDetail: fetchDetail,
      masterRole_save: save,
      masterRole_fetchDropdown: fetchDropdown,
    },
  } = useStores()

  /**
   * @description Get role list
   *
   * @param {IRoleGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterRole_fetchList = useCallback(
    (payload: IRoleGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Get role detail
   *
   * @param {IRoleGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterRole_fetchDetail = useCallback(
    (payload: IRoleGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Save role
   *
   * @param {IRoleSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterRole_save = useCallback(
    (payload: IRoleSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        save({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [save],
  )

  /**
   * @description Get role dropdown
   *
   * @param {IRoleGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterRole_fetchDropdown = useCallback(
    (payload: IRoleGetDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDropdown({
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDropdown],
  )

  return {
    masterRole_loading,
    masterRole_list,
    masterRole_detail,
    masterRole_dropdown,
    masterRole_CLEAR_LIST,
    masterRole_CLEAR_DETAIL,
    masterRole_CLEAR_DROPDOWN,
    masterRole_fetchList,
    masterRole_fetchDetail,
    masterRole_save,
    masterRole_fetchDropdown,
  }
}

export { useMasterRole }
